import { FlaskConical } from 'lucide-react';

import { TextTip } from '@@/Tip/TextTip';
import { InsightsBox } from '@@/InsightsBox/InsightsBox';

export function ExperimentalFeaturesSettingsForm() {
  return (
    <div className="space-y-4">
      <TextTip color="blue" icon={FlaskConical}>
        Experimental features may be discontinued without notice.
      </TextTip>

      <div className="text-muted small">
        In Portainer releases, we may introduce features that we&apos;re
        experimenting with. These will be items in the early phases of
        development with limited testing.
        <br />
        Our goal is to gain early user feedback, so we can refine, enhance and
        ultimately make our features the best they can be. Disabling an
        experimental feature will prevent access to it.
      </div>

      <div className="mt-6 mb-4">
        <InsightsBox
          header="No experimental features available"
          type="slim"
          content={
            <div className="space-y-3">
              <div>
                There are currently no experimental features to configure. Check
                back in future releases for new experimental functionality.
              </div>
            </div>
          }
          className="mb-3"
        />
      </div>
    </div>
  );
}
